/* Zohan — Main JS */

// ── Intersection Observer — scroll reveal
const observer = new IntersectionObserver((entries) => {
  entries.forEach(el => {
    if (el.isIntersecting) {
      el.target.classList.add('visible');
      observer.unobserve(el.target);
    }
  });
}, { threshold: 0.05, rootMargin: '0px 0px 60px 0px' });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

// ── Nav scroll shadow
window.addEventListener('scroll', () => {
  const nav = document.getElementById('main-nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 40);
}, { passive: true });

// ── Mobile menu (hamburguesa · categorías)
const hamburger = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobile-menu');
if (hamburger && mobileMenu) {
  const closeMenu = () => {
    mobileMenu.style.maxHeight = '0px';
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  };
  const openMenu = () => {
    mobileMenu.style.maxHeight = mobileMenu.scrollHeight + 'px';
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
  };
  hamburger.addEventListener('click', () => {
    const isOpen = mobileMenu.style.maxHeight && mobileMenu.style.maxHeight !== '0px';
    isOpen ? closeMenu() : openMenu();
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) closeMenu();
  });
}

// ── FAQ accordion
document.querySelectorAll('.faq-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isActive = item.classList.contains('active');
    document.querySelectorAll('.faq-item.active').forEach(i => i.classList.remove('active'));
    if (!isActive) item.classList.add('active');
  });
});

// ── Lightbox imagen de producto (tocar para ampliar)
(function () {
  const pImg = document.getElementById('main-product-img');
  if (!pImg) return;
  pImg.style.cursor = 'zoom-in';

  let overlay = null;

  const sizeToViewport = () => {
    if (!overlay) return;
    const vv = window.visualViewport;
    if (vv) {
      overlay.style.width = vv.width + 'px';
      overlay.style.height = vv.height + 'px';
      overlay.style.top = vv.offsetTop + 'px';
      overlay.style.left = vv.offsetLeft + 'px';
      overlay.style.right = 'auto';
      overlay.style.bottom = 'auto';
    }
  };

  const close = () => {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    document.body.style.overflow = '';
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', sizeToViewport);
      window.visualViewport.removeEventListener('scroll', sizeToViewport);
    }
  };

  const open = () => {
    close();
    const hi = pImg.currentSrc || pImg.src;
    const bigSrc = hi.replace(/width=\d+/, 'width=1600');
    overlay = document.createElement('div');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-label', 'Imagen ampliada');
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(10,8,6,.92);display:flex;align-items:center;justify-content:center;padding:1.25rem;cursor:zoom-out;';
    const big = document.createElement('img');
    big.src = bigSrc;
    big.alt = pImg.alt || '';
    big.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;border-radius:10px;box-shadow:0 20px 60px rgba(0,0,0,.5);';
    const closeBtn = document.createElement('button');
    closeBtn.setAttribute('aria-label', 'Cerrar');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute;top:14px;right:18px;width:44px;height:44px;border-radius:50%;border:none;background:rgba(255,255,255,.14);color:#fff;font-size:1.8rem;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;';
    overlay.appendChild(big);
    overlay.appendChild(closeBtn);
    overlay.addEventListener('click', close);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    sizeToViewport();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', sizeToViewport);
      window.visualViewport.addEventListener('scroll', sizeToViewport);
    }
  };

  pImg.addEventListener('click', open);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();
